import dayjs from 'dayjs'
import { changeTimeLocalToUtc } from '../../../helper'
import { DATE_FORMAT } from '../../../utils/constants'

class TradeForward {
  constructor(form, tradingAccountPrimeBrokerNormalize = {}) {
    this.trade_type = form.trade_type.name
    if (form.trade_type.name.includes('Client') && form.side) {
      this.side = form.side === 'BUY' ? 'SELL' : 'BUY'
    } else {
      this.side = form.side
    }
    this.price = Number(form.price)
    this.base_currency = form.currency_pair.substring(0, 3)
    this.counter_currency = form.currency_pair.substring(3, 6)
    this.counterparty = form.counterparty
    this.trade_date = changeTimeLocalToUtc(form.trade_date, DATE_FORMAT.REGULAR_DATE_TIME)
    this.value_date = form.value_date ? dayjs(form.value_date).format(DATE_FORMAT.REGULAR_DATE) : ''
    this.quantity = Number(form.quantity)
    this.direction = form.direction
    this.note = form.note
    this.is_conversion = form.is_conversion
    if (
      this.counterparty &&
      tradingAccountPrimeBrokerNormalize?.data?.trading_account_prime_broker[form.counterparty]
        .prime_broker === 'RBS'
    ) {
      this.bdr = form.bdr
      this.is_pba = form.is_pba
    }
    this.trade_origin = 'FXER'
  }
  // will work just when update
  isEqual({ trade, tradingAccountPrimeBrokerNormalize }) {
    let { trade_date, value_date } = trade
    trade_date = dayjs(trade_date).format(DATE_FORMAT.REGULAR_DATE_TIME)
    value_date = dayjs(value_date).format(DATE_FORMAT.REGULAR_DATE)
    trade.trade_type = trade.type
    trade.price = trade.client_price || trade.market_maker_price
    trade.quantity = Math.abs(trade.client_quantity) || Math.abs(trade.market_maker_quantity)
    trade.counterparty = trade.client || trade.market_maker
    trade = new TradeForward(trade, tradingAccountPrimeBrokerNormalize)
    trade.trade_date = trade_date
    trade.value_date = value_date
    for (const key of Object.keys(trade)) {
      if (this[key] !== trade[key]) {
        return false
      }
    }
    delete trade.trade_date
    return true
  }
}

export default TradeForward
